module.exports = __webpack_public_path__ + "static/media/money.ab03a629.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/giftcard/money.png
// module id = 1926
// module chunks = 6